import * as _dayjs2 from "dayjs";
var _dayjs = "default" in _dayjs2 ? _dayjs2.default : _dayjs2;
import { dew as _indexDew } from "../../../index";
import { dew as _casualReferencesDew } from "../../../common/casualReferences";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  var __createBinding = exports && exports.__createBinding || (Object.create ? function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
      enumerable: true,
      get: function () {
        return m[k];
      }
    });
  } : function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
  });
  var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function (o, v) {
    Object.defineProperty(o, "default", {
      enumerable: true,
      value: v
    });
  } : function (o, v) {
    o["default"] = v;
  });
  var __importStar = exports && exports.__importStar || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
  };
  var __importDefault = exports && exports.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  const dayjs_1 = __importDefault(_dayjs);
  const index_1 = _indexDew();
  const references = __importStar(_casualReferencesDew());
  const PATTERN = /今日|当日|昨日|明日|今夜|今夕|今晩|今朝/i;
  class JPCasualDateParser {
    pattern() {
      return PATTERN;
    }
    extract(context, match) {
      const text = match[0];
      const date = dayjs_1.default(context.refDate);
      const components = context.createParsingComponents();
      switch (text) {
        case "\u6628\u65E5":
          return references.yesterday(context.reference);
        case "\u660E\u65E5":
          return references.tomorrow(context.reference);
        case "\u4ECA\u65E5":
        case "\u5F53\u65E5":
          return references.today(context.reference);
      }
      if (text == "\u4ECA\u591C" || text == "\u4ECA\u5915" || text == "\u4ECA\u6669") {
        components.imply("hour", 22);
        components.assign("meridiem", index_1.Meridiem.PM);
      } else if (text.match("\u4ECA\u671D")) {
        components.imply("hour", 6);
        components.assign("meridiem", index_1.Meridiem.AM);
      }
      components.assign("day", date.date());
      components.assign("month", date.month() + 1);
      components.assign("year", date.year());
      return components;
    }
  }
  exports.default = JPCasualDateParser;
  //# sourceMappingURL=JPCasualDateParser.js.map
  return exports;
}